import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Pencil = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.44 4.78 4.198 16.02a2 2 0 0 0-.565 1.125l-.553 3.774 3.775-.553A2 2 0 0 0 7.98 19.8L19.22 8.56m-3.78-3.78 1.23-1.23a1.6 1.6 0 0 1 2.262 0l1.518 1.518a1.6 1.6 0 0 1 0 2.263L19.22 8.56m-3.78-3.78 3.78 3.78M5 16l3 3"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Pencil) as SvgIcon;
export { ForwardRef as ReactComponent };
